import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeatureCollection } from 'geojson';

@Injectable({
  providedIn: 'root'
})
export class ResultMapService {

  constructor(private http: HttpClient) { }

  get(projectId: number, simulationId: number) {
    return this.http.get<FeatureCollection>(`/api/project/${projectId}/simulation/${simulationId}/result-map`);
  }

  getSquares(projectId: number, simulationId: number) {
    return this.http.get<FeatureCollection>(`/api/project/${projectId}/simulation/${simulationId}/square-map`);
  }
}
